



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';

// Core styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Bg from '../../images/shapes/bg_pattern_2.svg';

const CARD_HEIGHT = 260;
const CARD_MIN_HEIGHT = 220;
const EXPANDED_CARD_HEIGHT = 350;

const Testimonial = () => {
  const [testimonial, setTestimonial] = React.useState([]);
  const [expandedCards, setExpandedCards] = useState({});

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  // Function to get initials from name
  const getInitials = (name) => {
    if (!name) return 'U';
    
    const names = name.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    
    const firstName = names[0];
    const lastName = names[names.length - 1];
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  };

  // Function to get first image from array or return null if empty
  const getFirstImage = (imageArray) => {
    if (!imageArray || imageArray.length === 0) {
      return null;
    }
    return imageArray[0];
  };

  // Toggle read more/less
  const toggleReadMore = (id) => {
    setExpandedCards(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // Function to check if message needs "Read More"
  const needsReadMore = (message) => {
    const lineCount = message.split('\n').length;
    return lineCount > 4 || message.length > 200;
  };

  // Function to render star rating
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <i key={`full-${i}`} className="fas fa-star" style={{ color: '#ffc107' }}></i>
      );
    }

    if (hasHalfStar) {
      stars.push(
        <i key="half" className="fas fa-star-half-alt" style={{ color: '#ffc107' }}></i>
      );
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <i key={`empty-${i}`} className="far fa-star" style={{ color: '#ffc107' }}></i>
      );
    }

    return stars;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get('https://api.rashtechinfo.com/getApprovedFeedback');
        console.log(data);
        setTestimonial(Array.isArray(data) ? data : []);
      } catch (e) {
        console.log(e);
      }
    };
    fetchData();
  }, []);

  

  return (
    <section className="review_section section_space">
      <div className="container">
        <div className="heading_block text-center">
          <div className="heading_focus_text">
            <span className="badge bg-secondary text-white">Client</span> Testimonial
          </div>
          <h2 className="heading_text mb-0">What clients say</h2>
        </div>

        <div className="row">
          <Swiper
            slidesPerView={1}
            spaceBetween={24}
            loop={true}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }}
            keyboard={{ enabled: true }}
            a11y={{ enabled: true }}
            breakpoints={{
              480: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
            }}
            style={{ paddingBottom: 32 }}
          >
            {testimonial.map((item, idx) => {
              const firstImage = getFirstImage(item.reviewImage);
              const isExpanded = expandedCards[item._id];
              const shouldShowReadMore = needsReadMore(item.message);
              
              return (
                <SwiperSlide key={item._id || idx}>
                  <div
                    className="review_block "
                    style={{
                      height: isExpanded ? EXPANDED_CARD_HEIGHT : CARD_HEIGHT,
                      minHeight: isExpanded ? EXPANDED_CARD_HEIGHT : CARD_MIN_HEIGHT,
                      display: 'flex',
                      flexDirection: 'column',
                      border: '1px solid rgba(0,0,0,0.06)',
                      borderRadius: 12,
                      background: '#fff',
                      padding: 20,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                      overflow: 'hidden',
                      transition: 'height 0.3s ease',
                      
                    }}
                  >
                    {/* Profile Section */}
                    <div className="review_profile_section" style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                      <div 
                        className="profile_image"
                        style={{
                          width: 50,
                          height: 50,
                          borderRadius: '50%',
                          overflow: 'hidden',
                          marginRight: 12,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: firstImage ? 'transparent' : '#007bff',
                          color: firstImage ? 'inherit' : 'white',
                          fontSize: 16,
                          fontWeight: 'bold'
                        }}
                      >
                        {firstImage ? (
                          <img 
                            src={`https://api.rashtechinfo.com/images/feedback/${firstImage}`} 
                            alt={item.name}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                          />
                        ) : (
                          getInitials(item.name)
                        )}
                      </div>
                      
                      <div className="profile_info">
                        <h4 className="review_admin_name" style={{ fontSize: 16, marginBottom: 2, fontWeight: '600' }}>
                          {item.name}
                        </h4>
                        <span className="review_admin_designation" style={{ fontSize: 13, color: '#777' }}>
                          {item.designation}
                        </span>
                      </div>
                    </div>

                    {/* Title */}
                    <h3
                      className="review_title"
                      style={{
                        fontSize: 18,
                        lineHeight: 1.3,
                        marginBottom: 8,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {item.title}
                    </h3>

                    {/* Rating Stars */}
                    <div className="rating_stars" style={{ marginBottom: 12 }}>
                      {renderStars(item.rating)}
                    </div>

                    {/* Message with Read More functionality */}
                    <div className="message_container" style={{ flex: 1, position: 'relative' }}>
                      <p
                        className="review_commtent"
                        style={{
                          fontSize: 14,
                          color: '#555',
                          lineHeight: 1.5,
                          marginBottom: 10,
                          display: '-webkit-box',
                          WebkitLineClamp: isExpanded ? 'unset' : 4,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: isExpanded ? 'unset' : 'ellipsis',
                          whiteSpace: 'normal'
                        }}
                      >
                        {item.message}
                      </p>
                      
                      {/* Read More/Less Button */}
                      {shouldShowReadMore && (
                        <button
                          onClick={() => toggleReadMore(item._id)}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#007bff',
                            fontSize: 13,
                            fontWeight: '500',
                            cursor: 'pointer',
                            padding: 0,
                            marginTop: 5
                          }}
                        >
                          {isExpanded ? 'Read Less' : 'Read More'}
                        </button>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        {/* Button Section */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-6 text-center">
            <ul className="btns_group unordered_list p-0 justify-content-center">
              <li>
                <Link onClick={ClickHandler} to="/review" className="btn">
                  <span className="btn_label" data-text="Your Feedback">
                    Your Feedback
                  </span>
                  <span className="btn_icon">
                    <i className="fa-solid fa-arrow-up-right"></i>
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;